import { ConversionItemStatus } from 'types/embedded/orderConversion';

export const CONVERSION_COLORS = {
  [ConversionItemStatus.Success]: '#81C784',
  [ConversionItemStatus.Failure]: '#EF5350',
  [ConversionItemStatus.Pending]: '#FDD835',
};
